// Querystring utility current consumed by Product Add-to-Cart scripts
(function ($) {
    $.querystring = (function (a) {
        var i,
            p,
            b = {};
        if (a === "") { return {}; }
        for (i = 0; i < a.length; i += 1) {
            p = a[i].split('=');
            if (p.length === 2) {
                b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
            }
        }
        return b;
    }(window.location.search.substr(1).split('&')));
}(jQuery));

(function($) {
  
  	$.updatequerystring = function (url, key, value) {
      //if (!url) url = window.location.href;
      
      var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
          hash;

      if (re.test(url)) {
          if (typeof value !== 'undefined' && value !== null)
              return url.replace(re, '$1' + key + "=" + value + '$2$3');
          else {
              hash = url.split('#');
              url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
              if (typeof hash[1] !== 'undefined' && hash[1] !== null) 
                  url += '#' + hash[1];
              return url;
          }
      }
      else {
          if (typeof value !== 'undefined' && value !== null) {
              var separator = url.indexOf('?') !== -1 ? '&' : '?';
              hash = url.split('#');
              url = hash[0] + separator + key + '=' + value;
              if (typeof hash[1] !== 'undefined' && hash[1] !== null) 
                  url += '#' + hash[1];
              return url;
          }
          else
              return url;
      }
	}
}(jQuery));


(function($) {
	$.setCookie = function(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    };
})(jQuery);


(function($) {
	$.getCookie = function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    };
})(jQuery);

function isMobileWidth() {
  return $('#mobile-indicator').is(':visible');
}

String.prototype.contains = function(value) {
  return this.indexOf(value) >= 0;
}

var ShopifyExt = ShopifyExt || {};


// Utility function which is explicitly invoked from Add to Cart buttons, and also invoked on page load
ShopifyExt.updateCartDisplay = function() {
  var success = function(data) {    
    var item_count_text = data.item_count == 1 ? "1 Item" : data.item_count + " Items";    
    var text = "Cart (" + item_count_text + ")";
    $(".cart-content").text(text);
  };
  
  $.ajax({
    type: "GET",
    url: '/cart.js',
    success: success,
    dataType: 'json'
  });
  
  return false;
};

$(document).ready(function(){
  	ShopifyExt.updateCartDisplay();
   	
  	// Error Handling function
  	Shopify.onError = function(XMLHttpRequest, textStatus) {
      // Shopify returns a description of the error in XMLHttpRequest.responseText.
      // It is JSON.
      // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
      
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
      } else {
        alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
      }

      $('.addtocart').removeAttr("disabled");
    };
	
    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };
})

jQuery(document).ready(function($){  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })    
}); // end document ready

